// @ts-nocheck

import * as _ from 'lodash';

const VALIDATORS = {
  required,
};

export function required(options) {
  const errorMsg = _.get(options, 'errorMessage', 'Value required');

  return function requiredValidator(value) {
    const valid = !_.isNull(value) && !_.isUndefined(value) && value.length;

    return {
      valid,
      msg: valid ? null : errorMsg,
    };
  };
}

const chain = (validators) =>
  function validatorChain(value) {
    let res;

    for (let i = 0; i < validators.length; i++) {
      res = validators[i](value);
      if (!res.valid) {
        return res;
      }
    }

    return res;
  };

export const createValidator = (...validators) => {
  const v = _.map(validators, (name) => {
    const fn = VALIDATORS[name];
    if (!fn) {
      throw new TypeError(`invalid validator name: '${name}'`);
    }
    return fn();
  });

  return v.length === 1 ? v[0] : chain(v);
};
